"use client";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Fade,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import PasswordField from "./CustomFields/PasswordField";
import ConfirmPasswordField from "./CustomFields/ConfirmPasswordField";
import {
  CFormHelperText,
  ContainedButton,
  CTypography,
  CustomFormLabel,
} from "./CustomStyles";
import axios from "axios";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
// import PasswordField from "@/components/PasswordFields/PasswordField";
// import ConfirmPasswordField from "@/components/PasswordFields/ConfirmPasswordField";

const ContinueButtonStyle = {
  marginTop: "8px",
  padding: "16px",
  borderRadius: "10px",
};

const ConfirmPassword = (props) => {
  const {
    email,
    phone,
    signInWith,
    setAuthSteps,
    changingToken,
    showToastWithMessage,
    handleConfirmPasswordFn,
  } = props;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isStrongPassword, setIsStrongPassword] = useState(false);

  useEffect(() => {
    console.log(password, "password");
  }, [password]);
  const handlePasswordChange = (newPassword) => {
    console.log(newPassword, "new password");
    setPassword(newPassword);
    setPasswordError("");
    // Custom validation for parent
    // if (newPassword.length < 8) {
    //   setError(true);
    // } else {
    //   setError(false);
    // }
  };

  const resetPasswordButtonHandler = () => {
    let errorOcurred = false;
    if (!isStrongPassword) {
      errorOcurred = true;
    }
    if (password == "") {
      setPasswordError("Password is required");
      errorOcurred = true;
    }
    if (confirmPassword == "") {
      setConfirmPasswordError("Password is required");
      errorOcurred = true;
    }
    if (confirmPassword != password) {
      setConfirmPasswordError("Make sure your passwords match");
      errorOcurred = true;
    }
    if (errorOcurred) {
      return false;
    }
    setShowLoader(true);
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["password"] = `${password}`;
        postData["changing_token"] = changingToken;
        postData["token"] = token;

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitPasswordForForgotPasswordEmail`, postData)
          .then((response) => {
            setShowLoader(false);
            if (!response?.data?.error) {
              setAuthSteps(0);
              showToastWithMessage(
                <>
                  Password changed <br /> Redirecting to login screen.
                </>
              );
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
              setErrorMessage(err?.response?.data?.message);
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };

  useEffect(() => {
    console.log(isStrongPassword, "isStrongPassword");
  }, [isStrongPassword]);

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <CTypography>
          You’ll be logged out of all active sessions after your password is
          changed.
        </CTypography>
        <Box>
          <CustomFormLabel>New password</CustomFormLabel>
          <PasswordField
            placeholder="Password"
            value={password}
            onChange={handlePasswordChange}
            error={passwordError != ""}
            helperText={passwordError}
            setIsStrongPassword={setIsStrongPassword}
          />
          {passwordError != "" && (
            <CFormHelperText sx={{ mt: 1, color: "#BA1A1A" }}>
              {passwordError}
            </CFormHelperText>
          )}
        </Box>
        <Box>
          <CustomFormLabel>Confirm new password</CustomFormLabel>
          <ConfirmPasswordField
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setConfirmPasswordError("");
            }}
            placeholder="Confirm new password"
            error={confirmPasswordError != ""}
            helperText={confirmPasswordError}
          />
        </Box>
        <ContainedButton
          onClick={(e) => resetPasswordButtonHandler()}
          variant="contained"
          sx={ContinueButtonStyle}
        >
          Reset Password
        </ContainedButton>
      </Box>
      <SimpleBackdrop open={showLoader} />
    </Box>
  );
};

export default ConfirmPassword;
